// Hide "Updated" toast notifications from browser extensions
document.addEventListener('DOMContentLoaded', function() {
  // Function to hide toasts containing "Updated"
  function hideUpdatedToasts() {
    const selectors = [
      '.toast',
      '.swal2-toast',
      '[class*="toast"]',
      '[class*="notification"]'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        const text = element.textContent || element.innerText || '';
        if (text.toLowerCase().includes('updated')) {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.opacity = '0';
          element.style.pointerEvents = 'none';
        }
      });
    });
  }
  
  // Run immediately
  hideUpdatedToasts();
  
  // Run periodically to catch dynamic toasts
  setInterval(hideUpdatedToasts, 1000);
  
  // Use MutationObserver to catch new toasts
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        hideUpdatedToasts();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
